import styled from '@emotion/styled'

export const Eta = styled.p(() => ({
  margin: 0,
  fontSize: '20px',
  color: '#262626'
}))
